import { Navigate, useNavigate } from 'react-router-dom';
import { useAuthStore } from '@stores/authStore';
import { WelcomeIntro } from './WelcomeIntro';

export default function WelcomePage() {
  const navigate = useNavigate();

  // Get the user's authentication status from the auth store
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  // Redirect authenticated users to the dashboard to prevent
  // them from accessing the welcome page again
  if (isAuthenticated) {
    // return <Navigate to="/dashboard" replace />;
    return <Navigate to="/dashboard" />;
  }

  // Click "Continue"
  // Store a flag indicating that the welcome screen has been viewed
  // and redirect the user to the requested destination or login page
  const handleContinue = () => {
    useAuthStore.getState().setWelcomeSeen(true);
    navigate('/register', { replace: true });
  };

  return <WelcomeIntro onContinue={handleContinue} />;
}
